import type { CSSProperties, ReactNode } from 'react'

interface SellFormPanelProps {
  title: string
  lead?: string
  index?: number
  className?: string
  children: ReactNode
}

/** App-style card section for the sell listing form. */
export default function SellFormPanel({
  title,
  lead,
  index = 0,
  className = '',
  children,
}: SellFormPanelProps) {
  return (
    <div
      className={`sell-form-panel${className ? ` ${className}` : ''}`}
      style={{ '--sell-panel-i': index } as CSSProperties}
    >
      <div className="sell-form-panel__head">
        <h3 className="sell-form-panel__title">{title}</h3>
        {lead ? <p className="sell-form-panel__lead">{lead}</p> : null}
      </div>
      {children}
    </div>
  )
}
